module.exports = __webpack_public_path__ + "fonts/724e2fc.woff2";